"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createChiliPiperIntegration = exports.disconnectChiliPiperIntegration = exports.getChiliPiperIntegration = void 0;

var _utils = require("@alycecom/utils");

var PREFIX = 'COMMON/PERSONAL/INTEGRATIONS';
var getChiliPiperIntegration = (0, _utils.createAsyncAction)("".concat(PREFIX, "/GET_CHILI_PIPER_INTEGRATION"));
exports.getChiliPiperIntegration = getChiliPiperIntegration;
var disconnectChiliPiperIntegration = (0, _utils.createAsyncAction)("".concat(PREFIX, "/DISCONNECT_CHILI_PIPER_INTEGRATION"));
exports.disconnectChiliPiperIntegration = disconnectChiliPiperIntegration;
var createChiliPiperIntegration = (0, _utils.createAsyncAction)("".concat(PREFIX, "/CREATE_CHILI_PIPER_INTEGRATION"));
exports.createChiliPiperIntegration = createChiliPiperIntegration;